import { render, staticRenderFns } from "./WaitingPost.vue?vue&type=template&id=61dc8e03"
import script from "./WaitingPost.vue?vue&type=script&lang=js"
export * from "./WaitingPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports